import React from 'react';

import { useRecordContext } from 'components/record/useRecordContext';
import { Check, Map } from '@mui/icons-material';
import { BooleanField, LinkField, ListField } from 'components/list/Fields';
import List from 'components/list/List';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ActionMenuItemEdit from 'components/list/actionMenu/ActionMenuItemEdit';
import ActionMenuItemDelete from 'components/list/actionMenu/ActionMenuItemDelete';
import CreateButton from 'components/forms/CreateButton';
import SubEventForm from './SubEventForm';
import { ResourceContextProvider } from 'components/record/ResourceContext';
import ImportSubEventsMenu from './ImportSubEventsMenu';
import useIsOrienteering from 'hooks/useIsOrienteering';
import ActionMenuItemLink from 'components/list/actionMenu/ActionMenuItemLink';
import { Box, Stack, Typography } from '@mui/material';
import { OpenInNew, Wifi } from '@mui/icons-material';
import BulkExportIofXml from './BulkExportIofXml';

const SubEvents = () => {
  const { record: event } = useRecordContext();
  const isOrienteering = useIsOrienteering();

  return (
    <ResourceContextProvider resource="SubEvent" params={{ slug: event.slug }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Manage races and stages belonging to this event.
        </Typography>
      </Box>
      <List
        bulkOptions
        hidePagination
        title="Subevents"
        avatar={<Map />}
        bulkActions={<BulkExportIofXml />}
        toolbar={
          <Stack direction="row" spacing={1} alignItems="center">
            <CreateButton size="small" label="Subevent" maxWidth="lg" defaultValues={{useGPS: true, public: true}}>
              <SubEventForm includeMap event={event} />
            </CreateButton>
            {isOrienteering && <ImportSubEventsMenu />}
          </Stack>
        }
      >
        <LinkField source="name" label="Subevent" link={(subEvent) => `/sub_events/${subEvent?.id}`} />
        <ListField source="sub" label="Abbreviation" />
        <BooleanField source="useGPS" label="GPS">
          <Check color="success" />
        </BooleanField>
        <BooleanField source="public" label="Public">
          <Check color="success" />
        </BooleanField>
        <ActionMenu label="" align="right" width="5%" variant="cell">
          <ActionMenuItemLink
            label="Open"
            icon={<OpenInNew fontSize="small" />}
            href={(subEvent) => import.meta.env.VITE_DOMAIN_EVENTS + `${event.slug}/${subEvent?.sub}`}
          />
          <ActionMenuItemLink
            label="Live tracking"
            icon={<Wifi fontSize="small" />}
            href={(subEvent) => import.meta.env.VITE_DOMAIN_EVENTS + `${event.slug}/${subEvent?.sub}`}
          />
          <ActionMenuItemEdit confirmContent={<SubEventForm />} />
          <ActionMenuItemDelete />
        </ActionMenu>
      </List>
    </ResourceContextProvider>
  );
};

export default SubEvents;
